// What you are told about, which today is one thing.
//
// ============================================ THIS PAGE IS DELIBERATELY EMPTY
//
// The design pack's version has five rows with switches on them: something was
// published to a stand, a file of personal data was produced, a screen stopped
// reporting, passcodes are bouncing, and a daily summary while a show is
// running. Four have switches and one is locked on.
//
// NONE OF THE FIVE EXISTS. api/src/auth/delivery.ts is the only thing in this
// service that sends mail, `CodeAudience` is a closed union of two members, and
// both members are a six-digit code: `operator_sign_in` to somebody signing in
// here, `attendee_verification` to a stranger at a stand. There is no publish
// notice, no export notice, no watchdog on a quiet screen, no bounce alarm and
// no digest. There is also no table to store a preference in and no route to
// set one through.
//
// SO THE SWITCHES ARE NOT BUILT, AND THAT IS THE POINT RATHER THAN A SHORTFALL.
// Five toggles that save nowhere is the worst outcome available on this screen,
// and it is worse than it sounds. Somebody turns off "a file was produced",
// reads the confirmation, and believes they have stopped an email that was
// never going to arrive — and, more expensively, believes the other four are
// arriving. The page that says "there is one email and this is it" leaves a
// reader knowing something true. The page with switches on it leaves them
// believing they are being watched over.
//
// It is a route and a nav item anyway, rather than a tab hidden until there is
// something to put on it. The pack's menu has three items, the third is this,
// and a menu item that leads to a page saying what does not exist yet is how
// somebody stops looking for a setting they will not find.

import type { ReactNode } from "react";
import { NoticeBox, PageHead } from "@nova/desk-ui/parts";
import { SecLabel } from "@nova/desk-ui/kit";

export function Notices(): ReactNode {
  return (
    <div className="stack">
      <PageHead
        title="Notifications"
        lede="Emails sent to this account. These settings do not affect attendee messages."
        explain="info"
      />

      {/* The design's page: the one notice that exists, then what does not,
          beside it rather than inside its panel. The address the codes go to
          is on Account. */}
      <section>
        <SecLabel>Sign-in</SecLabel>
        <div className="panel panel-stack">
          <div className="fac">
            <div>
              <p className="fac-t">Your one-time passcode</p>
              <p className="fac-d">
                Six digits sent when you ask to sign in. Each code expires quickly and works once.
              </p>
            </div>
            <span className="tag tag-good">Always on</span>
          </div>
        </div>
      </section>

      <NoticeBox kind="amber" title="Only sign-in codes are available today">
        <p>
          Console does not yet send alerts for exports, publishes, screen outages, bounced codes or
          daily summaries. There are no notification settings to change yet.
        </p>
        <p className="help help-tight">Open an activation to review its activity.</p>
      </NoticeBox>
    </div>
  );
}
